<template>
    <v-btn
        class="white--text ma-4"
        color="light-blue darken-4"
        href="https://keithvictordawson.medium.com/"
    >
        <v-icon class="blue--text text--lighten-3">{{ icons.post }}</v-icon>
        <span class="ml-2">View Medium</span>
    </v-btn>
</template>

<script>
import { mdiPost } from '@mdi/js'

export default {
    name: 'BlogMediumButton',
    data() {
        return {
            icons: {
                post: mdiPost,
            },
        }
    },
}
</script>